import { useCallback } from 'react';

import type { DxfViewerSession } from '../session/types';

/**
 * Connects `DxfRotateControls` to the page's DXF viewer session.
 *
 * Rotation is a viewport operation — clicking a button here re-renders nothing —
 * so the hook only hands the component the two callbacks it needs to fire.
 */
export const useDxfRotateControls = (session: DxfViewerSession) => {
  const onRotateClockwise = useCallback(
    () => session.viewport.rotate(1),
    [session],
  );
  const onRotateCounterClockwise = useCallback(
    () => session.viewport.rotate(-1),
    [session],
  );

  return {
    onRotateClockwise,
    onRotateCounterClockwise,
  };
};
